import React, {createContext, Dispatch, SetStateAction, useMemo, useState} from 'react';
import {useVideoControl} from '~/common/hooks/useVideoControls';
import {FabricObject} from '~/common/fabric/types';
import {OverlayVideo} from '~/QuickEcards/components/OverlayAnimation/OverlayAnimation';

type EcardContextProps = {
  setCanvas: (prevCanvas: unknown) => void;
  canvas: unknown;
  activeObjects: unknown[];
  setActiveObjects: Dispatch<SetStateAction<FabricObject[]>>;
  effectVideo: OverlayVideo | null;
  revealVideo: OverlayVideo | null;
};

const defaultContextValue: EcardContextProps = {
  setCanvas: () => {},
  canvas: null,
  activeObjects: [],
  setActiveObjects: () => {},
  effectVideo: null,
  revealVideo: null,
};

export const EcardContext = createContext<EcardContextProps>(defaultContextValue);

export const EcardContextParent = ({children}: {children: React.ReactNode}) => {
  const [canvas, setCanvas] = useState<unknown>();
  const [activeObjects, setActiveObjects] = useState<FabricObject[]>([]);
  const effectVideo = useVideoControl();
  const revealVideo = useVideoControl();

  const context = useMemo(
    () => ({
      canvas,
      setCanvas,
      activeObjects,
      setActiveObjects,
      effectVideo,
      revealVideo,
    }),
    [canvas, activeObjects, effectVideo, revealVideo]
  );

  return <EcardContext.Provider value={context}>{children}</EcardContext.Provider>;
};
